import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Group } from '../../../api/api-checkout/models/rq-checkout-search';
import { GlobalComponent } from '../../../shared/global';
import { dataInitBooking } from '../../../shared/constants/constant-init';
import { DateUtils } from '../../../shared/utils/date-utils';
import { FlightItinerary } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class FlightDataService {
  private flightItinerary = new BehaviorSubject<FlightItinerary | null>(null);
  flightItinerary$ = this.flightItinerary.asObservable();

  set(
    departureSegments: number[],
    departureSegmentsIndexes: number[],
    returnSegment: number,
    returnSegmentIndex: number,
    flight: Group,
    transactionId: string,
    params?: any
  ) {
    try {
      const segments: number[] = departureSegments.map((item) => item);
      const segmentsIndex: number[] = departureSegmentsIndexes.map((item) => item);
      if (returnSegment >= 0) {
        segments.push(returnSegment);
        segmentsIndex.push(returnSegmentIndex);
      }

      GlobalComponent.segmentSelected = segments;
      GlobalComponent.appBooking = dataInitBooking;
      GlobalComponent.appBooking.segmentSelected = segments;
      GlobalComponent.indexSegmentSeleted = segmentsIndex;

      GlobalComponent.appGroupSeleted = flight;
      GlobalComponent.detailPricing = flight.detailPricing as any;

      const isDomestic = this.isDomestic(flight);
      GlobalComponent.isDomestic = isDomestic;

      const passengersQty =
        flight.detailPricing!.totalADT +
        flight.detailPricing!.totalCNN +
        flight.detailPricing!.totalINF;
      const totalDays = this.totalDaysTravel(flight);
      const data: FlightItinerary = {
        flight,
        isDomestic,
        segments,
        segmentsIndex,
        passengersQty,
        adultsQty: flight.detailPricing!.totalADT,
        childrenQty: flight.detailPricing!.totalCNN,
        infantsQty: flight.detailPricing!.totalINF,
        totalDays,
        params,
        transactionId,
      };
      this.flightItinerary.next(data);
    } catch (_) {
      this.flightItinerary.next(null);
    }
  }

  setValue(data: FlightItinerary) {
    this.flightItinerary.next(data);
  }

  getValue() {
    return this.flightItinerary.getValue();
  }

  getFlight() {
    return this.flightItinerary.getValue()?.flight;
  }

  totalDaysTravel(flight: Group) {
    const { departure, returns: returnFlight } = flight;

    let totalDaysTravel: number;
    let departureDate: Date;
    let arrivalDate: Date;

    if (departure.length === 1 && !returnFlight)
      arrivalDate = new Date(
        departure[0].segments[0].flightSegments[
          departure[0].segments[0].flightSegments.length - 1
        ].arrivalDateTime
      );
    else if (returnFlight)
      arrivalDate = new Date(
        returnFlight.segments[0].flightSegments[
          returnFlight.segments[0].flightSegments.length - 1
        ].arrivalDateTime
      );
    else
      arrivalDate = new Date(
        departure[departure.length - 1].segments[0].flightSegments[
          departure[departure.length - 1].segments[0].flightSegments.length - 1
        ].arrivalDateTime
      );

    departureDate = new Date(departure[0].segments[0].flightSegments[0].departureDateTime);
    totalDaysTravel = DateUtils.getDatesDiff(departureDate, arrivalDate) + 1;
    GlobalComponent.totalDaysTravel = totalDaysTravel;
    return totalDaysTravel;
  }

  isDomestic(flight: Group) {
    const countries = [
      flight.departure[0].originCity.country,
      flight.departure[0].destinationCity.country,
      ...(flight.returns
        ? [flight.returns.originCity.country, flight.returns.destinationCity.country]
        : []),
    ];

    return countries.every((country) => country === 'PE');
  }
}
